import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import { FLAG_OPTS, VitalFormik } from "../vital-constant";

interface HeartRateFieldProps {
  formik: VitalFormik;
  ind: number;
}

const HeartRateFields = ({ formik, ind }: HeartRateFieldProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid
      container
      sx={{
        gap: 2,
      }}
      size={12}
    >
      <Grid size={6.7}>
        <Input
          label={"BPM"}
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: "e.g. 72 (BPM)",
          }}
        />
      </Grid>
      <Grid size={4.8}>
        <CustomSelect
          label="Flag"
          name={getKey("flag")}
          options={FLAG_OPTS}
          value={activeVital?.flag}
          onChange={(v) => selectHandleChange("flag", v)}
        />
      </Grid>
    </Grid>
  );
};

export default HeartRateFields;
